<template>
  <b-container class="bv-example-row">
    <Header></Header>

    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-row class="border">
          <b-col cols="12">
            <b-row>
              <b-col cols="12" class="head">
                <h4>:: Auditoría de catálogo Salesforce</h4>
                <small class="text-muted">
                  Datos crudos del reporte oficial de Salesforce. No modifica el catálogo del cotizador.
                </small>
              </b-col>
            </b-row>

            <!-- ══ Resumen ══════════════════════════════════════════ -->
            <b-row v-if="stats" class="mt-2">
              <b-col cols="6" md="3" lg="2" class="mb-2">
                <div class="kpi">
                  <div class="kpi-value">{{ stats.total_catalogo }}</div>
                  <div class="kpi-label">Productos</div>
                </div>
              </b-col>
              <b-col cols="6" md="3" lg="2" class="mb-2">
                <div class="kpi">
                  <div class="kpi-value">{{ marcas.length }}</div>
                  <div class="kpi-label">Marcas</div>
                </div>
              </b-col>
              <b-col cols="6" md="3" lg="2" class="mb-2">
                <div class="kpi">
                  <div class="kpi-value">{{ stats ? stats.modelos_distintos : 0 }}</div>
                  <div class="kpi-label">Modelos</div>
                </div>
              </b-col>
              <b-col cols="6" md="3" lg="2" class="mb-2">
                <div class="kpi">
                  <div class="kpi-value">{{ stats ? stats.versiones_distintas : 0 }}</div>
                  <div class="kpi-label">Versiones</div>
                </div>
              </b-col>
              <b-col cols="12" md="6" lg="4" class="mb-2">
                <div class="kpi kpi-flags">
                  <b-badge
                    v-for="f in statsFlags"
                    :key="f.nombre"
                    :variant="variantDe(f.nombre)"
                    class="mr-1 mb-1"
                  >{{ etiquetaDe(f.nombre) }}: {{ f.total }}</b-badge>
                  <span v-if="!statsFlags.length" class="text-muted small">Sin incidencias</span>
                </div>
              </b-col>
            </b-row>

            <!-- ══ Filtros ══════════════════════════════════════════ -->
            <b-row class="mt-3">
              <b-col cols="12" md="6" lg="2" class="mb-2">
                <b-form-select v-model="filtro.brand" :options="opcionesMarca" @change="alCambiarMarca"></b-form-select>
              </b-col>
              <b-col cols="12" md="6" lg="2" class="mb-2">
                <b-form-select v-model="filtro.model" :options="opcionesModelo" :disabled="!filtro.brand" @change="alCambiarModelo"></b-form-select>
              </b-col>
              <b-col cols="12" md="6" lg="2" class="mb-2">
                <b-form-input v-model="filtro.version" placeholder="Versión (parcial)" @keyup.enter="buscar"></b-form-input>
              </b-col>
              <b-col cols="12" md="6" lg="2" class="mb-2">
                <b-form-select v-model="filtro.flag" :options="opcionesFlag"></b-form-select>
              </b-col>
              <b-col cols="12" md="6" lg="2" class="mb-2">
                <b-form-input v-model="filtro.q" placeholder="Buscar código / SAP..." @keyup.enter="buscar"></b-form-input>
              </b-col>
              <b-col cols="12" md="6" lg="2" class="mb-2">
                <b-button-group size="sm">
                  <b-button variant="primary" @click="buscar">Buscar</b-button>
                  <b-button variant="secondary" @click="limpiar">Limpiar</b-button>
                </b-button-group>
                <b-button size="sm" variant="outline-success" class="ml-1" @click="exportarCsv" :disabled="exportando">
                  {{ exportando ? '...' : 'CSV' }}
                </b-button>
              </b-col>
            </b-row>

            <!-- ══ Resultado ════════════════════════════════════════ -->
            <b-row class="mt-1">
              <b-col cols="12" class="text-muted small">
                {{ total }} producto(s) en la colección
                <span v-if="cargando"> — cargando...</span>
              </b-col>
              <b-col cols="12" class="text-right">
                <b-form-checkbox
                  v-model="verTodosLosCampos"
                  switch
                  class="small mb-0"
                >Ver los 14 campos del reporte</b-form-checkbox>
              </b-col>
            </b-row>

            <b-table
              striped
              hover
              small
              responsive
              :items="items"
              :fields="fields"
              :busy="cargando"
              sort-changed="alOrdenar"
              show-empty
              empty-text="No hay productos con esos filtros"
              class="mt-1"
            >
              <template slot="cell(brand)" slot-scope="row">
                <strong>{{ row.item.brand }}</strong>
              </template>

              <template slot="cell(model)" slot-scope="row">
                {{ row.item.model || '—' }}
              </template>

              <template slot="cell(version)" slot-scope="row">
                {{ row.item.version || '—' }}
              </template>

              <template slot="cell(sap_id)" slot-scope="row">
                <code v-if="row.item.sap_id">{{ row.item.sap_id }}</code>
                <b-badge v-else variant="danger">sin SAP</b-badge>
              </template>

              <template slot="cell(audit)" slot-scope="row">
                <span v-if="!row.item.audit.flags.length" class="text-success">OK</span>
                <b-badge
                  v-for="f in row.item.audit.flags"
                  :key="f"
                  :variant="variantDe(f)"
                  class="mr-1"
                >{{ etiquetaDe(f) }}</b-badge>
              </template>

              <!-- Columnas secundarias: ocultas por defecto -->
              <template slot="cell(code)" slot-scope="row">
                <code>{{ row.item.code || '—' }}</code>
              </template>
              <template slot="cell(ext_id)" slot-scope="row"><code>{{ row.item.ext_id || '—' }}</code></template>
              <template slot="cell(family)" slot-scope="row">{{ row.item.family || '—' }}</template>
              <template slot="cell(product_type)" slot-scope="row">{{ row.item.product_type || '—' }}</template>
              <template slot="cell(record_type)" slot-scope="row">{{ row.item.record_type || '—' }}</template>
              <template slot="cell(business_unit)" slot-scope="row">{{ row.item.business_unit || '—' }}</template>
              <template slot="cell(active)" slot-scope="row">{{ row.item.active || '—' }}</template>
              <template slot="cell(peru)" slot-scope="row">{{ row.item.peru || '—' }}</template>
              <template slot="cell(created_by)" slot-scope="row">{{ row.item.created_by || '—' }}</template>
              <template slot="cell(created_at_raw)" slot-scope="row">{{ row.item.created_at_raw || '—' }}</template>
              <template slot="cell(source_row)" slot-scope="row">{{ row.item.source_row || '—' }}</template>
            </b-table>

            <b-row v-if="paginas > 1">
              <b-col cols="12" class="d-flex justify-content-center">
                <b-pagination
                  v-model="pagina"
                  :total-rows="total"
                  :per-page="porPagina"
                  :page-options="opcionesPagina"
                  type="button"
                  @input="cargarProductos"
                ></b-pagination>
              </b-col>
            </b-row>

            <b-alert show variant="danger" v-if="error">{{ error }}</b-alert>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import Header from './Header';

// Etiquetas legibles para los flags de auditoría
const FLAG_ETIQUETAS = {
  sin_codigo: 'Sin código',
  sin_sap: 'Sin SAP',
  modelo_generico: 'Modelo genérico',
  modelo_tecnico: 'Modelo técnico',
  codigo_duplicado: 'Código duplicado',
  nombre_duplicado: 'Nombre duplicado',
  linea_no_auto: 'No es auto'
};

const FLAG_VARIANTES = {
  sin_codigo: 'danger',
  sin_sap: 'danger',
  modelo_generico: 'warning',
  modelo_tecnico: 'info',
  codigo_duplicado: 'warning',
  nombre_duplicado: 'secondary',
  linea_no_auto: 'warning'
};

export default {
  name: "Auditoria",
  components: { Header },
  data() {
    return {
      // Columnas visibles por defecto (el resto se revela con el switch)
      verTodosLosCampos: false,

      items: [],
      total: 0,
      pagina: 1,
      porPagina: 50,
      opcionesPagina: [25, 50, 100, 200],
      paginas: 0,
      cargando: false,
      exportando: false,
      error: '',

      marcas: [],
      modelos: [],
      versiones: [],
      filtro: { brand: '', model: '', version: '', flag: '', q: '' },
      orden: { campo: 'brand', dir: 1 },
      stats: null,

      flagsDisponibles: Object.keys(FLAG_ETIQUETAS)
    };
  },
  computed: {
    fields() {
      const base = [
        { key: 'brand', label: 'Marca', sortable: true },
        { key: 'model', label: 'Modelo', sortable: true },
        { key: 'version', label: 'Versión / Nombre', sortable: true },
        { key: 'sap_id', label: 'Id interno SAP' },
        { key: 'audit', label: 'Auditoría' }
      ];
      const ocultas = [
        { key: 'code', label: 'Código de producto', sortable: true },
        { key: 'ext_id', label: 'Id externo' },
        { key: 'family', label: 'Familia' },
        { key: 'product_type', label: 'Tipo de producto' },
        { key: 'record_type', label: 'Tipo de registro' },
        { key: 'business_unit', label: 'Agrupamiento' },
        { key: 'active', label: 'Activo' },
        { key: 'peru', label: 'Perú' },
        { key: 'created_by', label: 'Creado por' },
        { key: 'created_at_raw', label: 'Fecha creación' },
        { key: 'source_row', label: 'Fila Excel', sortable: true }
      ];
      return this.verTodosLosCampos ? base.concat(ocultas) : base;
    },

    opcionesMarca() {
      return [{ value: '', text: 'Todas las marcas' }].concat(
        this.marcas.map(m => ({ value: m, text: m }))
      );
    },
    opcionesModelo() {
      return [{ value: '', text: 'Todos los modelos' }].concat(
        this.modelos.map(m => ({ value: m, text: m }))
      );
    },
    opcionesFlag() {
      return [{ value: '', text: 'Todos los estados' }].concat(
        this.flagsDisponibles.map(f => ({
          value: f,
          text: FLAG_ETIQUETAS[f] + (this.stats && this.stats.flags[f]
            ? ' (' + this.stats.flags[f] + ')'
            : '')
        }))
      );
    },
    statsFlags() {
      if (!this.stats || !this.stats.flags) return [];
      const flags = this.stats.flags;
      return this.flagsDisponibles
        .filter(f => flags[f])
        .map(f => ({ nombre: f, total: flags[f] }));
    }
  },
  created() {
    document.title = "Auditoría catálogo — Derco";
    if (!localStorage.getItem('jwtToken')) {
      this.$router.push({ name: 'Login' });
      return;
    }
    axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");

    this.cargarMarcas();
    this.cargarStats();
    this.cargarProductos();
  },
  methods: {
    etiquetaDe(flag) {
      return FLAG_ETIQUETAS[flag] || flag;
    },
    variantDe(flag) {
      return FLAG_VARIANTES[flag] || 'secondary';
    },

    // ── Datos auxiliares ─────────────────────────────────────────
    cargarMarcas() {
      axios.get('/auditoria/filters')
        .then(r => { this.marcas = r.data.brands || []; })
        .catch(this.onError);
    },
    cargarStats() {
      axios.get('/auditoria/stats')
        .then(r => { this.stats = r.data; })
        .catch(() => { /* las tarjetas son informativas: no bloquean la tabla */ });
    },

    // ── Tabla principal ──────────────────────────────────────────
    cargarProductos() {
      this.cargando = true;
      const params = {
        brand: this.filtro.brand,
        model: this.filtro.model,
        version: this.filtro.version,
        flag: this.filtro.flag,
        q: this.filtro.q,
        page: this.pagina,
        limit: this.porPagina,
        sort: this.orden.campo,
        order: this.orden.dir === 1 ? 'asc' : 'desc'
      };
      axios.get('/auditoria/products', { params })
        .then(r => {
          this.items = r.data.items || [];
          this.total = r.data.total || 0;
          this.paginas = r.data.pages || 1;
          this.error = '';
        })
        .catch(this.onError)
        .then(() => { this.cargando = false; });
    },

    buscar() {
      this.pagina = 1;
      this.cargarProductos();
      this.cargarStats();
    },

    limpiar() {
      this.filtro = { brand: '', model: '', version: '', flag: '', q: '' };
      this.modelos = [];
      this.pagina = 1;
      this.buscar();
    },

    alCambiarMarca() {
      this.filtro.model = '';
      this.filtro.version = '';
      this.modelos = [];
      this.versiones = [];
      if (!this.filtro.brand) {
        this.buscar();
        return;
      }
      axios.get('/auditoria/filters', { params: { brand: this.filtro.brand } })
        .then(r => { this.modelos = r.data.models || []; })
        .catch(this.onError);
      this.buscar();
    },

    alCambiarModelo() {
      this.filtro.version = '';
      this.versiones = [];
      this.buscar();
    },

    alOrdenar(ctx) {
      this.orden = { campo: ctx.sortBy, dir: ctx.sortDesc ? -1 : 1 };
      this.pagina = 1;
      this.cargarProductos();
    },

    // ── Exportación ─────────────────────────────────────────────
    exportarCsv() {
      this.exportando = true;
      axios.get('/auditoria/export.csv', {
        params: this.filtro,
        responseType: 'blob'
      }).then(r => {
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = 'auditoria-catalogo-salesforce.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }).catch(this.onError)
        .then(() => { this.exportando = false; });
    },

    onError(e) {
      this.cargando = false;
      if (e.response && e.response.status === 401) {
        localStorage.removeItem('jwtToken');
        this.$router.push({ name: 'Login' });
        return;
      }
      this.error = 'Error al cargar datos: ' +
        (e.response ? (e.response.status + ' ' + e.response.statusText) : e.message);
    }
  }
};
</script>

<style scoped>
.head h4 {
  margin-bottom: 0.2rem;
}

.kpi {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.5rem;
  text-align: center;
  background-color: #f8f9fa;
  height: 100%;
}

.kpi-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #c8102e;
}

.kpi-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6c757d;
}

.kpi-flags {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Auditoria.vue